import { reinitializePlugins } from '../../plugins/pluginUtils';

export const createTextFeatures = (editor) => ({
  insertText(text, position = 'cursor', tagName = 'p') {
    if (!editor) return;

    // Убедимся, что тег валиден
    const validTags = ['p', 'h1', 'h2', 'h3', 'h4'];
    if (!validTags.includes(tagName)) {
      console.error(`Invalid tag: ${tagName}. Valid tags are ${validTags.join(', ')}`);
      return;
    }

    editor.chain().focus();

    let content;
    if (tagName === 'p') {
      // Если тег `p`, вставляем просто текст
      content = text;
    } else {
      // Для остальных тегов оборачиваем в HTML-тег
      content = `<${tagName}>${text}</${tagName}>`;
    }

    switch (position) {
      case 'start':
        // Вставить в начало
        editor.commands.insertContentAt(0, content);
        break;

      case 'end':
        // Вставить в конец
        editor.commands.insertContentAt(editor.state.doc.content.size, content);
        break;

      case 'cursor':
      default:
        // Вставить в текущее положение курсора
        editor.commands.insertContent(content);
        break;
    }
  },

  pasteHeadings(headingsList) {
    if (!headingsList || !headingsList.length) return;
    
    headingsList.forEach((heading) => {
        this.insertText(heading.title, 'end', heading.tag);
    });

    reinitializePlugins();
  },

  insertBlock(text) {
    if (editor) {

      try {
        editor.commands.insertContent(text);
      } catch (error) {
        console.error('Error updating text:', error);
      }
    }
  },

  updateText(text, { from, to }) {
    editor.chain()
      .focus()
      .deleteRange({ from, to })
      .insertContent(text)
      .run();
  }
});
